import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { UserPreference } from '../models';
import { SessionService } from './session.service';
import { UserPreferenceService } from './user-preference.service';

@Injectable({
  providedIn: 'root',
})
export class CurrencySelectService {
  private readonly userPreferenceService = inject(UserPreferenceService);
  private readonly sessionService = inject(SessionService);

  static CurrencyKey = 'Currency';
  skipUserPreferenceService = false;
  currentCurrency: string;

  getCurrency(): Observable<string> {
    return (
      this.skipUserPreferenceService ? of(undefined) : this.userPreferenceService.get(CurrencySelectService.CurrencyKey)
    ).pipe(
      map((userPreference: UserPreference) => {
        let currency = userPreference?.value;
        if (!currency) {
          currency = this.sessionService.getString(CurrencySelectService.CurrencyKey);
          if (currency && !this.skipUserPreferenceService) {
            this.userPreferenceService.set(CurrencySelectService.CurrencyKey, currency).subscribe();
          }
        }
        const localCurrency = this.sessionService.getString(CurrencySelectService.CurrencyKey);
        if (localCurrency !== currency) {
          this.setCurrency(currency).subscribe();
        }

        this.currentCurrency = currency;
        return currency;
      }),
    );
  }

  setCurrency(currency: string): Observable<any> {
    this.currentCurrency = currency;
    if (currency) {
      this.sessionService.setString(CurrencySelectService.CurrencyKey, currency);
      if (!this.skipUserPreferenceService) {
        return this.userPreferenceService
          .set(CurrencySelectService.CurrencyKey, currency)
          .pipe(tap(() => location.reload()));
      }
    }
    return of(undefined);
  }
}
